// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"pi","modalContent":"qi","header":"ri","close":"si"};